<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{form.main.aql_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.aql_name" slot="aql_name">
            <label class="weui-form-preview__label">{{customLabel.aql_name || "AQL"}}</label>
            <em class="weui-form-preview__value">{{form.main.aql_name}}</em>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.aql_remark" slot="aql_remark">
            <label class="weui-form-preview__label">{{customLabel.aql_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{form.main.aql_remark}}</span>
          </div>
         
          <div class="weui-form-preview__item" slot="aql_default">
            <label class="weui-form-preview__label">{{customLabel.aql_default || "默认"}}</label>
            <span class="weui-form-preview__value">{{form.main.aql_default ? '是' : '否'}}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.ad_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          
          <div class="weui-form-preview__item"  slot="ad_qty"> 
            <label class="weui-form-preview__label">{{customLabel.ad_qty || "样本量"}}</label>
            <span class="weui-form-preview__value">{{item.ad_qty}}</span>
          </div>
          <div class="weui-form-preview__item"  slot="ad_ng_max">
            <label class="weui-form-preview__label">{{customLabel.ad_ng_max || "最大不合格允收数"}}</label>
            <span class="weui-form-preview__value">{{item.ad_ng_max}}</span>
          </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "录入人"}}</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "录入日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.createTime}}</span>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
   components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/qcaql",
      caller:'QcAql',
      xtype:'stock-qcAql-formpanel'
    };
  }
};
</script>